import request from '@/config/axios'
import { TransferReqVO } from '@/api/crm/permission'

export interface ClueVO {
  id: number // 编号
  name: string // 公司名称（原「线索名称」）
  contactName: string // 联系人姓名
  followUpStatus: boolean // 跟进状态
  contactLastTime: Date // 最后跟进时间
  contactLastContent: string // 最后跟进内容
  requirement: string // 需求概述
  contactNextTime: Date // 下次联系时间
  visitTime: Date // 来访时间
  ownerUserId: number // 负责人的用户编号；为空表示在线索池中
  ownerUserName?: string // 负责人的用户名称
  ownerUserDept?: string // 负责人的部门名称
  followerUserId: number // 跟进人编号（谁跟）
  followerUserName?: string // 跟进人名称（谁跟）
  poolTime: Date // 进入线索池的时间
  transformStatus: boolean // 转化状态
  customerId: number // 客户编号
  customerName?: string // 客户名称
  mobile: string // 手机号
  telephone: string // 电话
  message: string // 留言信息
  qq: string // QQ
  wechat: string // wechat
  product: string // 产品
  email: string // email
  visitKeyword: string // 来访关键词
  areaId: number // 所在地
  areaName?: string // 所在地名称
  ip: string // IP
  detailAddress: string // 详细地址
  zipCode: string // 邮编
  industryId: number // 所属行业
  level: number // 客户等级
  source: number // 客户来源
  detailRequirement: string // 详细需求
  remark: string // 备注
  creator: string // 创建人（列表「申请人」列）
  creatorName?: string // 创建人名称
  createTime: Date // 创建时间
  updateTime: Date // 更新时间
}

// 查询线索列表
export const getCluePage = async (params: any) => {
  return await request.get({ url: `/crm/clue/page`, params })
}

// 查询线索详情
export const getClue = async (id: number) => {
  return await request.get({ url: `/crm/clue/get?id=` + id })
}

// 新增线索
export const createClue = async (data: ClueVO) => {
  return await request.post({ url: `/crm/clue/create`, data })
}

// 修改线索
export const updateClue = async (data: ClueVO) => {
  return await request.put({ url: `/crm/clue/update`, data })
}

// 删除线索
export const deleteClue = async (id: number) => {
  return await request.delete({ url: `/crm/clue/delete?id=` + id })
}

// 导出线索 Excel
export const exportClue = async (params) => {
  return await request.download({ url: `/crm/clue/export-excel`, params })
}

// 线索转移
export const transferClue = async (data: TransferReqVO) => {
  return await request.put({ url: '/crm/clue/transfer', data })
}

// 线索转化为客户
export const transformClue = async (id: number) => {
  return await request.put({ url: '/crm/clue/transform', params: { id } })
}

// 获得分配给我的、待跟进的线索数量
export const getFollowClueCount = async () => {
  return await request.get({ url: '/crm/clue/follow-count' })
}

// ==================== 线索池 ====================

// 将线索转入线索池
export const putCluePool = async (ids: number[]) => {
  return await request.put({ url: '/crm/clue/put-pool', params: { ids: ids.join(',') } })
}

// 将线索池中的线索转为我的线索
export const receiveClue = async (ids: number[]) => {
  return await request.put({ url: '/crm/clue/receive', params: { ids: ids.join(',') } })
}

// 导入线索（导入的线索一律进入线索池）
export const importClue = async (data: FormData, updateSupport: boolean) => {
  return await request.upload({
    url: `/crm/clue/import`,
    params: { updateSupport },
    data
  })
}

// 下载线索导入模板
export const getClueImportTemplate = async () => {
  return await request.download({ url: '/crm/clue/get-import-template' })
}
